<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->

  <el-container class="index-con">
    <el-aside :class="showclass" v-show="showDhcd">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header" v-show="showDhcd">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main" v-show="showDhcd">
        <router-view></router-view>
      </el-main>

      <el-main clss="index-main" v-show="!showDhcd" style="background-color: #F5F5F5">
        <router-view></router-view>
      </el-main>

    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false,
      showDhcd: true,
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })

    // 判断 是否需要导航菜单
    var href = window.location.href;
    if (href.indexOf('goods/student') != -1) {
      this.showDhcd = false;
    } else {
      this.showDhcd = true;
    }
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功

    /*this.$message({
      message: '登录成功',
      type: 'success'
    })*/
  }
}
</script>
<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #014160;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #014160;
  margin: 0px;
}
.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #012d42;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue